import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
export function api__deleteDoc(_x, _x2, _x3) {
  return _api__deleteDoc.apply(this, arguments);
}
function _api__deleteDoc() {
  _api__deleteDoc = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(documentId, orderId, isFinance) {
    var formData, apiUrl, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          formData = new FormData();
          formData.append("document_key", documentId);
          formData.append("order_id", orderId);
          apiUrl = isFinance ? "/finance-tracking/delete-document" : "/order-tracking/delete-document";
          _context.n = 1;
          return fetcher().post(apiUrl, formData);
        case 1:
          res = _context.v;
          if (!(res.data.code !== 200)) {
            _context.n = 2;
            break;
          }
          throw new Error("Failed to delete documents");
        case 2:
          return _context.a(2, res.data);
      }
    }, _callee);
  }));
  return _api__deleteDoc.apply(this, arguments);
}